import { render, staticRenderFns } from "./manage-booking-receipt-info-header.vue?vue&type=template&id=02ab019c&scoped=true"
import script from "./manage-booking-receipt-info-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./manage-booking-receipt-info-header.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./manage-booking-receipt-info-header.vue?vue&type=style&index=0&id=02ab019c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ab019c",
  null
  
)

export default component.exports